<script>
    export let msg;
</script>

<div
    class="container center-contents-vh blue text-align-center min-height-2rem"
>
    {msg}
</div>
